import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import './styles/index.scss'
import installIcons from '@/icons'
import './permission.js'
import i18n from '@/i18n'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import installFilter from '@/filter/index.js'
import installDirective from '@/directives/index.js'

const app = createApp(App)
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}
installIcons(app)
installFilter(app)
installDirective(app)
app.use(store)
app.use(router)
app.use(ElementPlus)
app.use(i18n)
app.mount('#app')
